module.exports = __webpack_public_path__ + "assets/img/white-customer-5.6287ee82.png";